export enum ContactSelectorQuickFilterType {
  CUSTOMERS = 'customers',
  COLLEAGUES = 'colleagues',
}
